// extracted by mini-css-extract-plugin
export default {"pageWrapper":"pageWrapper__1zjqo","footer":"footer__26Gm8","width100vw":"width100vw__U_pMw","bottomCard":"bottomCard__1mIjp"};